<script setup lang="ts">
import { computed } from 'vue'

import DolphinChip from '@/components/atoms/DolphinChip.vue'
import { getQuestionStatusName, type TextQuestion } from '../calendarQuestion'

const { question, formError } = defineProps<{
  question: TextQuestion
  formError: string | undefined
}>()
const statusName = computed(() => getQuestionStatusName(question.status))
</script>
<template>
  <div :class="$style.input">
    <div :class="$style.questionText">
      <div :class="$style.questionText__label">
        <label :class="$style.questionText__labelText">
          <template v-if="question.questionText !== ''">
            {{ question.questionText }}
          </template>
          <span v-else :class="$style['questionText__labelText--warning']">
            この質問を選択して質問内容を編集してください
          </span>
        </label>
        <DolphinChip :class="$style.questionText__chip">{{
          statusName
        }}</DolphinChip>
      </div>
      <div :class="$style.questionText__dummyForm">サンプルテキスト</div>
      <p v-if="formError" :class="$style.questionText__error">
        {{ formError }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.questionText {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 24px;
  }

  &__labelText {
    font-size: 16px;
    line-height: 1;
    font-weight: bold;

    &--warning {
      color: $color-text-and-object-accent-red;
    }
  }

  &__chip {
    color: $color-text-and-object-high-emphasis;
    background-color: $color-surface-secondary;
  }

  &__error {
    color: $color-caution-accent;
    font-size: 12px;
  }

  &__dummyForm {
    border-radius: $border-radius-v2-base;
    border: 1px solid $color-border-low-emphasis;
    height: 24px;
    padding: 12px;
    background-color: $color-surface-primary;
  }
}
</style>
